export default "__VITE_ASSET__BGeyZhgX__"